import { render, staticRenderFns } from "./DeleteTagModal.vue?vue&type=template&id=3ab2b010&scoped=true&"
import script from "./DeleteTagModal.vue?vue&type=script&lang=js&"
export * from "./DeleteTagModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab2b010",
  null
  
)

export default component.exports